import { FC } from 'react'
import { GridCardSkeleton, ObjectOverviewCardSkeleton } from '../../../common/card-skeletons'
import { GridRowWrapper, ListItemWrapper } from './styles'

interface Props {
    isGridView: boolean
    gridItemsPerRow?: number
}

const SkeletonRow: FC<Props> = ({ isGridView, gridItemsPerRow = 3 }) => {
    return isGridView ? (
        <GridRowWrapper>
            {Array.from({ length: gridItemsPerRow }).map((_, i) => (
                <GridCardSkeleton key={i} />
            ))}
        </GridRowWrapper>
    ) : (
        <ListItemWrapper>
            <ObjectOverviewCardSkeleton />
        </ListItemWrapper>
    )
}

export default SkeletonRow
